import React, { Component } from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import './styles.css';
import Icon from '../Icon';
import SetVariableMutation from '../../mutations/SetVariable';
import GameQuery from '../../query/GameQuery';
class StarsSpinner extends Component {
	render() {
		const { variable, output, min, starsCount } = this.props;
		return (
			<GameQuery>
				{
					query => (
						<SetVariableMutation>
							{setVariable => (
								<div
									className={`stars-spinner ${
										variable.disabled ? 'stars-spinner-disabled' : ''
									} ${output ? 'stars-spinner-output' : 'stars-spinner-input'}`}
								>
									{range(1, starsCount + 1).map(
										n =>
											n <= variable.value ? (
												<Icon
													onClick={() =>  this.handleClick(setVariable, n >= min ?n:min, query.game)}
													key={n}
													icon="starFull"
												/>
											) : (
												<Icon
													onClick={() => this.handleClick(setVariable, n, query.game)}
													key={n}
													icon="starEmpty"
												/>
											)
									)}
								</div>
							)}
						</SetVariableMutation>
					)
				}
			</GameQuery>
		);
	}
	handleClick(setVariable, value, game) {
		const { variable, disabled, onChange, n } = this.props;
		const {
			name,
			year,
		} = variable;
		!variable.disabled &&
			!disabled &&
			setVariable({
				variables: {
					gameID: game.id,
					submission:game.lastSubmission,
					name,
					year,
					value
				}
			}).then(() => {
				onChange(n, value);
			});
	}
}

StarsSpinner.propTypes = {
	variable: PropTypes.object,
	output: PropTypes.bool
};

StarsSpinner.defaultProps = {
	min: 0,
	starsCount: 5,
	onChange: () => {}
};

export default StarsSpinner;
